import type { FieldElements } from "lib/zephr/complete-profile-fields";

const ANGEL_INVESTOR = "Angel Investor";
const SECTOR_COMPANY_TYPES = ["Startup", "Scaleup"];

export const CREATE_ACCOUNT_REQUIRED_FIELDS = [
  "first_name",
  "last_name",
  "form_role_at_business",
  "form_company_name",
  "form_company_type",
  "form_country",
  "agree_to_have_data_stored",
];

export const CHECKOUT_REQUIRED_FIELDS = [
  "first_name",
  "last_name",
  "form_role_at_business",
  "form_company_name",
  "agree_to_have_data_stored",
];

export const CHECKOUT_DEFERRED_FIELDS = [
  "form_country",
  "form_company_type",
  "form_sector",
  "form_professional_service_type",
  "form_investment_firm_type",
  "form_advisory_firm_type",
];

export const applyCreateAccountRequirements = (
  fields: FieldElements,
  { checkout }: { checkout: boolean }
): void => {
  const notAngelInvestor =
    fields["form_role_at_business"]?.value !== ANGEL_INVESTOR;

  if (fields["form_company_name"]) {
    fields["form_company_name"].required = notAngelInvestor;
  }

  if (checkout) {
    for (const name of CHECKOUT_DEFERRED_FIELDS) {
      if (fields[name]) {
        fields[name].required = false;
      }
    }
    return;
  }

  const companyType = fields["form_company_type"]?.value;

  if (fields["form_company_type"]) {
    fields["form_company_type"].required = notAngelInvestor;
  }

  if (fields["form_professional_service_type"]) {
    fields["form_professional_service_type"].required =
      companyType === "Professional Services";
  }

  if (fields["form_investment_firm_type"]) {
    fields["form_investment_firm_type"].required =
      companyType === "Investment Firm";
  }

  if (fields["form_sector"]) {
    fields["form_sector"].required = SECTOR_COMPANY_TYPES.includes(
      companyType as string
    );
  }

  if (fields["form_advisory_firm_type"]) {
    fields["form_advisory_firm_type"].required =
      companyType === "Advisory Firm";
  }
};
